import { useEffect, useRef } from 'react';
import {
  TextInput,
  TextInputProps,
  useGetMany,
  useSimpleFormIteratorItem,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { Item } from '../../types';

export const LinesDescriptionInput = (
  props: Omit<TextInputProps, 'children'>
) => {
  const iterator = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();

  const itemId = useWatch<Item>({ name: `lines.${iterator.index}.item` });
  const currentDescription = useWatch({ name: `lines.${iterator.index}.description` });
  const previousItemId = useRef<string>(itemId);

  const { data } = useGetMany<Item>(
    'items',
    {
      ids: [itemId],
    },
    { enabled: !!itemId }
  );
  const description = data?.[0]?.Description;
  
  useEffect(() => {
    // Set description when item changes OR when we have a new item but no description set
    if (previousItemId.current !== itemId || (description && !currentDescription)) {
      setValue(`lines.${iterator.index}.description`, description);
      previousItemId.current = itemId;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, previousItemId, description, currentDescription]);
  return <TextInput {...props} />;
};
